import React from 'react';
import './arrowButton.scss';
import { ArrowInterface } from './arrowTypes';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';

const ArrowButton: React.FC<ArrowInterface> = ({
  direction,
  disabled,
  extraClass,
  onClick,
}) => (
  <button
    className={`arrowButton arrowButton--${direction} ${extraClass}`}
    type="button"
    disabled={disabled}
    onClick={onClick}
  >
    <Arrow className="arrow" />
  </button>
);

export default ArrowButton;
